import Vue from "vue";
// import Cookies from 'js-cookie';

// 文件数据类
export const mongeApp = Vue.observable({
  // 图纸
  map: {
    fileInfo: localStorage.getItem('dwgdata'), // 图纸信息
    spaceOfDwgData: '', // 图纸空间的fileName
    annotationData: '', // 云线数据
    annotationList: [], // 所有云线信息
    annoMapList: [],
    overlayList: [], // 叠图列表
    closeLayer: 0
  },
  // 模型
  model: {
    allFileList: [],
    isNoLightweight: false,
    modelReady: false,
    fileInfo: localStorage.getItem('modeldata'), // 模型信息
    urlFileIdList: [],
    hasDwg: false, // 有无展示模型图纸
    modelPageFileName: '',
    modelId: '',
    elementId: '',
    modelMapList: [], // app使用
    showElementIdlist: [], // 树形结构所有的构件key id列表（自定义）
    hiddenElementIdList: [],
    annotationData: ''
  },
  // 其他预览文件
  other: {
    fileInfo: localStorage.getItem('documentData')
  },
  shareId: '',
  shareToken: "",
  mlibEnabled: false, // 启动新的模式， true 为启用
  questionId: '', // 问题id
  hasList: false, // 有无展示问题列表
  dicList: [], // 问题字典
  legendBoolean: false, // 版本比对的图例
  showApp: true, // 应用按钮是否显示
  refreshKey: 1
});

export const mongeMutations = {
  changeMlibEnabled(Boolean) {
    mongeApp.mlibEnabled = Boolean;
  },
  // 公共
  setHasList(Boolean) {
    mongeApp.hasList = Boolean;
  },
  changeRefreshKey() {
    mongeApp.refreshKey++;
  },
  setQuestionId(value) {
    mongeApp.questionId = value;
  },
  changeShowApp(Boolean) {
    mongeApp.showApp = Boolean;
  },
  setDicList(val) {
    mongeApp.dicList = val;
  },
  setShareId(val) {
    mongeApp.shareId = val || '';
  },
  // 非引擎文件
  setDocmentView(value) {
    localStorage.setItem('documentData', value);
    mongeApp.other.fileInfo = value;
  },
  // 图纸
  setDwgData(value) {
    localStorage.setItem('dwgdata', value);
    mongeApp.map.fileInfo = value;
  },
  setSpaceOfDwgData(value) {
    mongeApp.map.spaceOfDwgData = value;
  },
  setOverlayList(val) {
    mongeApp.map.overlayList = val || [];
  },
  openLegend(Boolean) {
    mongeApp.legendBoolean = Boolean;
  },
  openMapDetail(id) {
    const annoMapList = mongeApp.map.annoMapList;
    mongeApp.questionId = annoMapList.find(e => e.id === id).questionId;
  },
  addMapList(val) {
    let annoMapList = mongeApp.map.annoMapList;
    if (val) {
      annoMapList.push(val);
    } else {
      annoMapList = [];
    }
  },
  hasCloseLayer() {
    mongeApp.map.closeLayer++;
  },
  setAnnotationData(val) {
    mongeApp.map.annotationData = val;
  },
  setModelMapData(val) {
    mongeApp.model.annotationData = val || "";
  },
  // 模型
  openModelReady(Boolean) {
    mongeApp.model.modelReady = Boolean;
  },
  setIsNoLightweight(Boolean) {
    mongeApp.model.isNoLightweight = Boolean;
  },
  setModelInfo (value) {
    localStorage.setItem('modeldata', value);
    mongeApp.model.fileInfo = value;
  },
  setHasDwg(Boolean) {
    mongeApp.model.hasDwg = Boolean;
  },
  setModelPageFileName(val) {
    mongeApp.model.modelPageFileName = val || "";
  },
  setModelProps(modelId, elementId) {
    mongeApp.model.modelId = modelId;
    mongeApp.model.elementId = elementId;
  },
  setModelMapList(val) {
    mongeApp.model.modelMapList = val;
  },

  addshowElementIdlist(val) {
    mongeApp.model.showElementIdlist.push(val);
  },
  clearshowElementIdlist() {
    mongeApp.model.showElementIdlist = [];
  },
  addHiddenElementIdlist(val) {
    mongeApp.model.hiddenElementIdList.push(val);
  },
  clearHiddenElementIdlist() {
    mongeApp.model.hiddenElementIdList = [];
  },
  setAllFileList(val) {
    mongeApp.model.allFileList = val;
  },
  setUrlFileIdList(obj) {
    mongeApp.model.urlFileIdList.push(obj);
  },
  clearUrlFileIdList() {
    mongeApp.model.urlFileIdList = [];
  }

};
